<template>
  <div>


    <div class="header bg-gradient-success pb-6 pb-8 pt-5 pt-md-8">
      <h4 class="profile-section-title"><i class="ni ni-align-center"></i>گزارشات فست ترک </h4>
    </div>
    <div class="container-fluid mt--7">
      <div class="card card-stats" show-footer-line="true">
        <!---->
        <div class="card-body dashboard-top-status">
          <div class="content-current-profile">
            <main>
              <div>
                <div id="tabs" class="tabs">
                  <nav>
                    <ul>
                      <li title="گزارش فروش" class="icon-booking" :class="{ 'tab-current': tabIndex == 0 }"
                        @click="tabIndex = 0">
                        <a class="icon-confirmed-report">
                          <span>گزارش فروش</span>
                        </a>
                      </li>
                      <li title="گزارش ورودی" class="icon-booking" :class="{ 'tab-current': tabIndex == 1 }"
                        @click="tabIndex = 1">
                        <a class="icon-new-report">
                          <span> گزارش ورودی</span>
                        </a>
                      </li>
                    </ul>
                  </nav>

                  <div class="content">
                    <saleReport v-if="tabIndex == 0" />
                    <entryReport v-if="tabIndex == 1" />
                  </div>
                </div>
                <!-- End tabs -->
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import saleReport from "./FastTrackSaleReport";
import entryReport from "./FastTrackEntryReport";

export default {
  name: "dolphinTabs",
  components: {
    saleReport,
    entryReport,
  },
  data: function () {
    return {
      tabIndex: 0,
    };
  },
};
</script>


